export default __webpack_public_path__ + "ab17e60dcbcd633703e98a81b714e90c.png";